export enum R {
    SignIn = '/login',
    SignUp = '/sign-up',
    // ForgotPassword = '/forgot-password',
}
